import { render, staticRenderFns } from "./StclN_Items_SpecialPrice.vue?vue&type=template&id=12a95164"
import script from "./StclN_Items_SpecialPrice.vue?vue&type=script&lang=js"
export * from "./StclN_Items_SpecialPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports